// Light, dark, or the device's own setting (Amit, 2026-10-01). One choice of
// three, so it is a real radio group: one tab stop, arrow keys move the choice,
// and a screen reader hears "Theme, Dark, 2 of 3". Each option is a 44px target
// like everything else in the office shell. The sidebar is dark in both themes,
// so the switch is styled once.
import { useState } from 'react';
import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { chooseTheme, savedTheme, type ThemeChoice } from '../lib/theme';

const OPTIONS: Array<{ value: ThemeChoice; label: string; icon: LucideIcon; title: string }> = [
  { value: 'light', label: 'Light', icon: Sun, title: 'Light' },
  { value: 'dark', label: 'Dark', icon: Moon, title: 'Dark' },
  { value: 'auto', label: 'Auto', icon: Monitor, title: "Follow this device's setting" },
];

export function ThemeSwitch() {
  const [choice, setChoice] = useState<ThemeChoice>(savedTheme);

  return (
    <fieldset className="m-0 grid grid-cols-3 gap-[2px] rounded-(--radius-sm) border-0 bg-white/[0.05] p-[3px]">
      <legend className="sr-only">Theme</legend>
      {OPTIONS.map(({ value, label, icon: Icon, title }) => (
        <label
          key={value}
          title={title}
          className={[
            'flex min-h-[44px] cursor-pointer items-center justify-center gap-[6px] rounded-[6px] text-[12px] font-semibold',
            'transition-colors duration-150 motion-reduce:transition-none',
            'has-focus-visible:ring-2 has-[:focus-visible]:ring-brand',
            choice === value
              ? 'bg-(--sidebar-active) text-(--sidebar-fg)'
              : 'text-(--n-300) hover:text-(--sidebar-fg)',
          ].join(' ')}
        >
          <input
            type="radio"
            name="quality-theme"
            value={value}
            checked={choice === value}
            onChange={() => {
              chooseTheme(value);
              setChoice(value);
            }}
            className="sr-only"
          />
          <Icon aria-hidden="true" className="h-[15px] w-[15px]" strokeWidth={1.75} />
          {label}
        </label>
      ))}
    </fieldset>
  );
}

export default ThemeSwitch;
